import { render } from "./RadiologyRejectionTab.vue?vue&type=template&id=5d2efb19"
import script from "./RadiologyRejectionTab.vue?vue&type=script&lang=js"
export * from "./RadiologyRejectionTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__